import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fontSizes } from 'syf-component-library/defaultTheme';
import { Button } from 'syf-component-library/ui/atoms';
import MessageBox from 'syf-component-library/ui/patterns/MessageBox/MessageBox';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import { Body, H5 } from 'syf-component-library/ui/typography';
import { DATA_ANALYTICS, DATA_TYPE, PAGE_FUNCTION, PAGE_NAME } from '../../../../const/analytics';
import { FAS_EXCLAMATION_CIRCLE } from '../../../../const/iconProps';
import MainContext from '../../../../Context';
import { t } from '../../../../strings/i18n';
const EnrollInAutopayButton = styled(Button) `
  margin: 0;
  padding: 0;
  font-size: ${fontSizes.root}px;
`;
const OneClickAutopayErrorBanner = ({ isOneTimeSuccess }) => {
    const { triggerAnalyticsEvent, sendToMainMachine } = useContext(MainContext);
    const navigateToEnrollInAutopay = () => {
        sendToMainMachine({
            type: 'SET_AUTOPAY_FLOW',
            isPaymentTypeVisible: false
        });
        triggerAnalyticsEvent({
            pageFunction: PAGE_FUNCTION.MAKE_PAYMENT.AUTOPAY,
            pageName: PAGE_NAME.START
        });
    };
    return (_jsx(MessageBox, Object.assign({ type: "info" }, { children: _jsxs(Inset, Object.assign({ all: "small" }, { children: [_jsx(H5, { children: t('autopay.autopayDetails') }), _jsx(Stack, {}), _jsx(MessageBox, Object.assign({ icon: _jsx(FontAwesomeIcon, { icon: FAS_EXCLAMATION_CIRCLE, size: "lg" }), role: "alertdialog", type: "error" }, { children: _jsx(Body, { children: t('autopay.oneClickAutopayFailedMessage') }) })), _jsx(Stack, {}), _jsx(EnrollInAutopayButton, Object.assign({ buttonType: "text", "data-analytics": DATA_ANALYTICS.CLICK_TRACKING_EVENT, "data-object": "link", "data-reason": isOneTimeSuccess
                        ? 'enroll in autopay onetime success'
                        : 'enroll in autopay onetime failure', "data-testid": "enroll-in-autopay-button-error-banner", "data-type": DATA_TYPE.MAKE_A_PAYMENT, onClick: navigateToEnrollInAutopay }, { children: t('button.enrollInAutopay') }))] })) })));
};
export default OneClickAutopayErrorBanner;
